export default __webpack_public_path__ + "static/media/group-3-img4.8e056cab.png";